import config from '@/config/configClient.json?v=2.2';

export default function getClientConfig() {
  const hostname = window.location.hostname;
  return config[hostname] || config['localhost'];
}
